import React from 'react';
import AreaIndicatorWidgetFactory from './area-indicator/AreaIndicatorWidgetFactory';
import OrganizationWidgetFactory from './organization/OrganizationWidgetFactory';

const WidgetFactory = ({ widget, atPublicDashboard = false, password = null }) => {
    switch (widget.widgetType) {
        case 'AREA_INDICATOR':
            return <AreaIndicatorWidgetFactory widget={widget} atPublicDashboard={atPublicDashboard} password={password} />;
        case 'ORGANIZATION':
            return <OrganizationWidgetFactory widget={widget} atPublicDashboard={atPublicDashboard} password={password} />;
        default:
            return <div>Unknown widget type</div>;
    }
};

export default WidgetFactory;